import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.scss'

// 移除 StrictMode 避免開發模式下的雙重渲染
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)



